<template>
  <div @click="$emit('click')"><slot></slot></div>
</template>

<script>
export default {
  name: 'Button--Boxed'
}
</script>

<style lang="scss" scoped>
div{
  display: inline-block;
  margin:0 auto;
  border-style:solid;
  padding:2em;
  width:100%;
  max-width:(253/12*1em);
  text-transform: uppercase;
  &:active{
    color:white;
    background-color:black;
    [data-theme="dark"] &{
      color:black;
      background-color:white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Button--Boxed.vue?36ee0849